import { Injectable, isDevMode } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import * as Rx from 'rxjs/Rx';

@Injectable()
export class WebsocketService {
  private host = '';
  private subject: Rx.Subject<string>;
  constructor() {
    if (isDevMode()) {
      this.host = 'ws://' + window.location.hostname + ':' + 5000 + '/ws';
    } else {
      this.host = 'wss://' + window.location.hostname + '/ws';
    }
  }

  connect(taskID: string): Observable<string> {
    return Observable.create(observer => {
      let socket = new WebSocket(this.host);

      socket.onopen = (e) => {
        /* socket.on('task_' + taskID + '_', (results: string) => {
            observer.next(results); */
        socket.send(taskID);
      }

      socket.onmessage = observer.next.bind(observer);
      socket.onerror = observer.error.bind(observer);
      socket.onclose = observer.complete.bind(observer);
    });
  }

  public connect1(): Rx.Subject<string> {
    if (!this.subject) {
      this.subject = this.create(this.host);
    }
    return this.subject;
  }

  private create(url): Rx.Subject<string> {
    let ws = new WebSocket(url);

    let observable = Rx.Observable.create((obs: Rx.Observer<string>) => {
      ws.onmessage = obs.next.bind(obs);
      ws.onerror = obs.error.bind(obs);
      ws.onclose = obs.complete.bind(obs);
      return ws.close.bind(ws);
    });
    let observer = {
      next: (data: Object) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify(data));
        }
      }
    };
    return Rx.Subject.create(observer, observable);
  }
}
